document.addEventListener('DOMContentLoaded', () => {
    // .fade-in-on-scroll というクラスを持つすべての要素を監視対象とする
    const targets = document.querySelectorAll('.fade-in-on-scroll');

    // Intersection Observerの準備
    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            // isIntersectingプロパティがtrueの場合、つまり要素が画面内に入った場合
            if (entry.isIntersecting) {
                // is-visibleクラスを付与してアニメーションを開始させる
                entry.target.classList.add('is-visible');
                // 一度表示したら、もう「監視」する必要はない。解除する
                observer.unobserve(entry.target);
            }
        });
    });

    // すべての対象を「監視」に登録する
    targets.forEach(target => {
        observer.observe(target);
    });
});
